import React, { useEffect, useState } from 'react'
import Ads from '../Components/Ads'
import Category from '../Components/Category'
import Card from '../Components/Card'
import Splider from '../Components/Splider'
import Function from '../Components/Function'
import axios from 'axios'
import Loading from './Loading'
import { URL } from '../config'
import { useDispatch } from 'react-redux'
import { setHome } from '../redux/slices/HomeSlice'
import ProductsRequmendedCategories from '../Components/ProductsRequmendedCategories'


const MainScreen = () => {
  const dispatch = useDispatch()
  const [load,setLoad]=useState(false);
  useEffect(()=>{
    setLoad(true);
    // axios.get(`${URL}/api/home/get_categories_products`)
    // .then(function (response) {
    //   if(response.data.success){
    //     console.log(response.data);
    //     setCategories(response.data.data);
    //   }
    //   setLoad(false);
    //     })
    // .catch(function (error) {
    //   console.log('error');
    //   setLoad(false);
    // });
    axios.get(`${URL}/api/home`)
    .then(function (response) {
      if(response.data.success){
        console.log('response.data',response.data);
        dispatch(setHome(response.data.data))
      }
      setLoad(false);
        })
    .catch(function (error) {
      console.log('error');
      setLoad(false);
    });
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  },[])
  if(load)
    return <Loading/>
  return (
    <div className='content_style mt-lg-5 pt-5 mb-2'>
        <Ads/>
        <Category/>
        <ProductsRequmendedCategories/>
       <Function/>
 
    </div>  
  )
}

export default MainScreen
